module.exports = __webpack_public_path__ + "static/media/layout-grid.46aba195.svg";